import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useApiError } from '@/modules/common/hooks/use-api-error';

import { updateFormulaEntry } from '../api/formula-library.api';
import { FORMULA_ENTRIES_QUERY_KEY } from '../constants/reports-query-keys';

export const useUpdateFormulaEntry = () => {
  const queryClient = useQueryClient();
  const { displayToastErrorFromApiWithFallback } = useApiError();

  return useMutation({
    mutationFn: ({
      id,
      ...body
    }: {
      id: string;
      label?: string;
      formulaString?: string;
      dependsOn?: string[];
    }) => updateFormulaEntry(id, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: FORMULA_ENTRIES_QUERY_KEY });
    },
    onError: error => {
      displayToastErrorFromApiWithFallback(
        error,
        'authenticated.reports:toasts.formulaUpdateError'
      );
    },
  });
};
